import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing.space16,
    gap: theme.spacing.space16,
    position: "relative",
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, #000 100%)",
    backdropFilter: "blur(5px)",
    paddingTop: 80,
    textAlign: "center",
  },
  profileInfo: {
    display: "flex",
    gap: theme.spacing.space16,
    padding: `0 ${theme.spacing.space16}px`,
  },
  info: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    gap: theme.spacing.space4,
    justifyContent: "center",
  },
  infoItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: `calc(100vw - ${theme.spacing.space48}px - 80px)`,
  },
  username: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-all",
    textAlign: "left",
    margin: "0px " + theme.spacing.space4 + "px !important",
  },
  buttonsGroup: {
    display: "flex",
    gap: theme.spacing.space16,
    padding: `0 ${theme.spacing.space16}px`,
  },
  editIcon: {
    padding: theme.spacing.space8,
    color: theme.colors.TextDefault,
    alignItems: "center",
  },
  line: {
    width: `calc(100% - ${theme.spacing.space16 * 2}px)`,
    height: 1,
    background: "linear-gradient(90deg, #000 0%, #D9D9D9 50.5%, #000 100%)",
    margin: theme.spacing.space16,
  },
  avatarBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: -10,
    left: 0,
    objectFit: "cover",
  },
  button: {
    margin: `0 ${theme.spacing.space16}px`,
    width: `calc(100% - ${theme.spacing.space16 * 2}px) !important`,
  },
  progressContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing.space8,
  },
  levelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `0 ${theme.spacing.space16}px`,
  },
  gemNeeded: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  avatar: {
    position: "relative",
  },
  shop: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}));
